import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivityPackStatus, ActivityStatusType } from 'src/app/Modules/management/models/instance/activity-pacck-type.model';

@Component({
    selector: 'app-create-activity-pack-status-modal',
    templateUrl: './create-activity-pack-status-modal.component.html',
    styleUrls: ['./create-activity-pack-status-modal.component.scss'],
})
export class CreateActivityPackStatusModalComponent implements OnInit, OnDestroy {
    @Input() modalMode: string;
    @Input() activityStatusDetails: ActivityPackStatus;
    @Input() defaultStatusList: ActivityPackStatus[];

    colorDefault: string;
    statusTypeOptionToBeSelected: string; // this is for when modal is open we can display the option already selected in the dropdown
    activityStatusName: string;
    activityColor: string;
    activityStatusTypes: ActivityStatusType[];
    activityStatusForm: UntypedFormGroup;
    activityPackStatus: ActivityPackStatus;
    activityStatusTypeFormControlSub: Subscription;
    ngUnsubscribe: Subject<any>;
    ZERO_INDEX = 0;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private instanceDataService: InstanceDataService,
        private ngbActiveModal: NgbActiveModal,
        private customToastService: CustomToastService
    ) {
        this.activityPackStatus = new ActivityPackStatus();
    }

    ngOnInit(): void {
        this.ngUnsubscribe = new Subject();
        this.activityStatusTypes = this.instanceDataService.getActivityStatusType();
        if (this.modalMode === 'add') {
            this.statusTypeOptionToBeSelected = this.activityStatusTypes[this.ZERO_INDEX].activityPackTypeStatusTypeId;
            this.createFormControls();
        } else {
            this.defaultStatusList = this.defaultStatusList.filter((item) => item.name !== this.activityStatusDetails.name);
            this.initializeFormControls();
        }
        this.activityStatusTypeFormControlSub = this.activityStatusForm
            .get('status_type')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((statusTypeId: string) => {
                let statusTypeObject = this.activityStatusTypes.find((item) => {
                    return item.activityPackTypeStatusTypeId === statusTypeId;
                });
                this.colorDefault = statusTypeObject.colour;
            });
    }

    createFormControls() {
        this.activityStatusForm = this.formBuilder.group({
            status_name: [null, Validators.required],
            status_type: [this.statusTypeOptionToBeSelected, Validators.required],
        });
        let statusTypeObject = this.activityStatusTypes.find((item) => {
            return item.activityPackTypeStatusTypeId === this.statusTypeOptionToBeSelected;
        });
        this.colorDefault = statusTypeObject.colour;
    }

    getFormControlValues(): ActivityPackStatus {
        this.activityPackStatus.colour = this.colorDefault;
        this.activityPackStatus.name = this.activityStatusForm.get('status_name').value;
        this.activityPackStatus.activityPackTypeStatusType = this.activityStatusTypes.find(
            (item) => item.activityPackTypeStatusTypeId === this.activityStatusForm.get('status_type').value
        );
        this.activityPackStatus.isSelected = true;
        return this.activityPackStatus;
    }

    initializeFormControls() {
        this.activityStatusForm = this.formBuilder.group({
            status_name: [this.activityStatusDetails.name, Validators.required],
            status_type: [this.activityStatusDetails.activityPackTypeStatusType.activityPackTypeStatusTypeId, Validators.required],
        });
        this.colorDefault = this.activityStatusDetails.colour;
    }

    closeModalWithResult() {
        let modalResult = this.getFormControlValues();
        if (this.checkDuplicateName()) {
            this.customToastService.errorToast('Activity Status name is already exist!', 'Duplicate Name');
        } else {
            if (this.modalMode === 'add') {
                this.ngbActiveModal.close(modalResult);
            } else {
                this.activityStatusDetails.colour = modalResult.colour;
                this.activityStatusDetails.activityPackTypeStatusType = modalResult.activityPackTypeStatusType;
                this.activityStatusDetails.name = modalResult.name;
                this.ngbActiveModal.close(this.activityStatusDetails);
            }
        }
    }

    closeModalWithCancel() {
        this.ngbActiveModal.close(false);
    }

    // helper method to check duplicate name
    checkDuplicateName() {
        for (const activityPackStatus of this.defaultStatusList) {
            if (
                activityPackStatus.name.toLocaleLowerCase().replace(/ /g, '') ===
                this.activityStatusForm.get('status_name').value.toLocaleLowerCase().replace(/ /g, '')
            ) {
                return true;
            }
        }
    }

    ngOnDestroy(): void {
        this.activityStatusTypeFormControlSub.unsubscribe();
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
}
